export const DST_CHANGE_TYPES = {
  NO_CHANGE: "NO_CHANGE",
  DST_CHANGE_POSITIVE: "DST_CHANGE_POSITIVE",
  DST_CHANGE_NEGATIVE: "DST_CHANGE_NEGATIVE"
};
